export const debounce = (func, wait, immediate) => {
    let timeout;
    return function () {
        const context = this,
            args = arguments;
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        }, wait);
        if (callNow) func.apply(context, args);
    };
};

export const extractErrorFromResponse = (error, index = 0) => {
    if (error.response) {
        const err = error.response.data;
        if (err && err.erros) {
            const erros = err.erros;
            if (erros.length >= index + 1) return erros[index].erro;
        } else if (err && err.status !== 500) {
            return err.message;
        }
    }
    return 'Erro ao se comunicar com o servidor';
};

export const textoCampoObrigatorio = (campo) => {
    return `O campo ${campo} é obrigatório`;
};

export const pdfGen = (data, headers, isDownload = false) => {
    if (isDownload && window.navigator && window.navigator.msSaveBlob) {
        return window.navigator.msSaveBlob(data, headers.filename);
    }
    const filename = headers.filename;
    const link = document.createElement('a');
    link.target = '_blank';
    if (isDownload) {
        if (window.URL) {
            link.href = URL.createObjectURL(new File([data], headers.filename, { type: 'application/pdf' }));
        } else {
            link.href = data;
        }
        link.download = filename;
    } else {
        const blob = new Blob([data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            link.href = URL.createObjectURL(blob);
        }
    }
    link.click();
};

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function parseHttpHeaders(httpHeaders) {
    return httpHeaders
        .split('\n')
        .map((x) => x.split(/: */, 2))
        .filter((x) => x[0])
        .reduce((ac, x) => {
            ac[x[0]] = x[1];
            return ac;
        }, {});
}

export function isNullOrEmpty(value) {
    return value === null || value === undefined || value === '';
}

export const generateQueryParams = (params) =>
    Object.keys(params)
        .reduce(
            (acc, key) =>
                !isNullOrEmpty(params[key]) && params.hasOwnProperty(key)
                    ? [...acc, encodeURIComponent(key) + '=' + encodeURIComponent(params[key])]
                    : acc,
            []
        )
        .join('&');

export function onBeforeUnloadEvent(event) {
    if (
        event.origin !== process.env.REACT_APP_ALLOWED_ORIGIN_PATRIMONIO &&
        event.origin !== process.env.REACT_APP_ALLOWED_ORIGIN_PENHOR
    ) {
        return;
    }

    event.preventDefault();

    return (event.returnValue = '');
}

export const generateQueryParamsFromList = (lista, key) => {
    if (lista.length === 0) {
        return '';
    }

    const queryParams = lista.map((item) => `${key}=${encodeURIComponent(item)}`);
    const queryParamString = queryParams.join('&');

    return queryParamString;
};

export const isNotNull = (value) => {
    return value !== null;
};

export function isNotNullAndNotUndefined(value) {
    return value !== undefined && value !== null;
}

export const setOnBeforeUnloadEvent = () => {
    window.addEventListener('beforeunload', onBeforeUnloadEvent);
};

export const clearOnBeforeUnloadEvent = () => {
    window.removeEventListener('beforeunload', onBeforeUnloadEvent);
};
